export default __webpack_public_path__ + "static/media/undraw_dreamer_gxxi.fcae030e.svg";